import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		female: {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=female&exp=web_gamification_of_fallback_offer~1
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_gamification_of_fallback_offer__b'
					),
			},
		},
		'activity-female-tai-chi-walking-v2': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2&exp=web_gamification_of_fallback_offer~1
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_gamification_of_fallback_offer__b'
					),
			},
		},
		'female-water-fasting': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=female-water-fasting&exp=web_gamification_of_fallback_offer~1
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_gamification_of_fallback_offer__b'
					),
			},
		},
	},
	{
		female: {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=female&exp=web_gamification_of_fallback_offer~2
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_gamification_of_fallback_offer__c'
					),
			},
		},
		'activity-female-tai-chi-walking-v2': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2&exp=web_gamification_of_fallback_offer~2
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_gamification_of_fallback_offer__c'
					),
			},
		},
		'female-water-fasting': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=female-water-fasting&exp=web_gamification_of_fallback_offer~2
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_gamification_of_fallback_offer__c'
					),
			},
		},
	},
]

export default config
